import { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import callApi from '../services/ApiServices';
import { ImagePath } from '../components/common/ImagePath';
import CommonLoader from '../components/common/CommonLoader';
import CommonPagination from '../components/common/CommonPagination';
import { useNavigate } from 'react-router-dom';
import AddPayoutModal from '../components/common/AddPayoutModal';
import PayoutTransactions from '../components/common/PayoutTransactions';
import {useGlobalStates} from '../utlis/ClubsContext'
import {UserRole} from '../utlis/constant';

const RevenueManagement = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const[revenueData, setRevenueData] = useState([]);
  const[loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [openPayoutModal, setOpenPayoutModal] = useState(false);
  const[openTransactionModal, setOpenTransactionModal] = useState(false);
  const [clubDetail, setClubDetail] = useState(0);
  const navigate = useNavigate()
  const {userRole}=  useGlobalStates()
    const limit = 10;

    console.log("userRole", userRole)
  useEffect(()=>{
    fetchRevenueData(currentPage, limit, searchQuery)
  },[])
const fetchRevenueData = async(page, limit, searchQuery)=>{
  let ApiUrl = `admin/revenue-list?page=${page}&limit=${limit}`;
  if(searchQuery){
    ApiUrl += `&search=${searchQuery}`
  }
  if(!searchQuery){
    setLoading(true)
  }
  try {
    const res = await callApi({
      method: "get",
      url: ApiUrl,
    })
    console.log("Revenue Data", res)
    setRevenueData(res?.data)
    const totalitems = res?.pagination?.total
    const totalPages = Math.ceil(totalitems / limit);
    setTotalCount(totalPages)
  } catch (error) {
    console.log("revenue error", error)
  }finally{
    setLoading(false)
  }
}
const handlePageChange =(e)=>{
  setCurrentPage(e)
  fetchRevenueData(e, limit, searchQuery)
}

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(amount);
  };
const handlePayout = (club)=>{
 setOpenPayoutModal(true)
 setClubDetail(club)
}

  return (
    <>
      {/* Search Bar */}
      <div className="mb-6 relative w-full sm:w-auto sm:max-w-[320px]">
        <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
        <input
          type="search"
          placeholder="Search by club name, location..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
            fetchRevenueData(1, limit, e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === " " && searchQuery?.length === 0) {
              e.preventDefault();
            }
          }}
          className="w-full pl-12 pr-4 py-3 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent text-base text-black placeholder-textcolor"
        />
      </div>

      {/* Table Container */}
      <div className="bg-white rounded-[12px] shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            {/* Table Header */}
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200">
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Club Name
                </th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Location
                </th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Total Revenue
                </th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Revenue share to Club
                </th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Paid to Club
                </th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Pending Payouts
                </th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Payout transactions
                </th>
                <th className="px-6 py-4 text-left text-base font-medium text-black">
                  Actions
                </th>
              </tr>
            </thead>

            {/* Table Body */}
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="py-10 text-center">
                    <div className="flex items-center justify-center">
                      <CommonLoader fullScreen />
                    </div>
                  </td>
                </tr>
              ) : revenueData?.length > 0 ? (
                revenueData?.map((item, index) => (
                  <tr
                    key={item.id}
                    className={`border-b border-gray-100 hover:bg-gray-50 transition-colors ${
                      index === revenueData.length - 1 ? "border-b-0" : ""
                    }`}
                  >
                    {/* Club Name with Logo */}
                    <td className="px-6 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
                          <img
                            src={item.club_logo}
                            alt={item.clubName}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <span className="text-sm font-medium text-textcolor">
                          {item.club_name}
                        </span>
                      </div>
                    </td>

                    {/* Location */}
                    <td className="px-6 py-3">
                      <div className="text-sm text-textcolor">
                        {item.club_location},
                        <br />
                        {/* {item.location.split(',')[1]} */}
                      </div>
                    </td>

                    {/* Total Revenue */}
                    <td className="px-6 py-3">
                      <span className="text-sm font-medium text-textcolor">
                        {item?.total_revenue
                          ? formatCurrency(item?.total_revenue)
                          : "-"}
                      </span>
                    </td>

                    {/* Revenue Share */}
                    <td className="px-6 py-3">
                      <span className="text-sm text-textcolor">
                        {item?.revenue_for_club
                          ? formatCurrency(item?.revenue_for_club)
                          : "-"}
                        
                      </span>
                    </td>

                    {/* Paid to Club */}
                    <td className="px-6 py-3">
                      <span className="text-sm font-medium text-textcolor">
                        {item?.revenue_paid
                          ? formatCurrency(item?.revenue_paid)
                          : "-"}
                      </span>
                    </td>

                    {/* Pending Payouts */}
                    <td className="px-6 py-3">
                      <span className="text-sm font-medium text-textcolor">
                        {item?.revenue_pending
                          ? formatCurrency(item?.revenue_pending)
                          : "-"}
                      </span>
                    </td>
                    <td className="text-blue-500 hover:text-blue-800 cursor-pointer px-6 py-3"
                    onClick={()=>{setOpenTransactionModal(true)
                      setClubDetail(item)
                    }}
                    >View history</td>
                    <td className="px-6 py-3">
                      <div className="flex items-center gap-4">
                        <button
                          onClick={() => {
                            navigate(
                              `/transactions?clubName=${item?.club_name}`,
                            );
                          }}
                          className="p-1 hover:bg-gray-100 rounded transition-colors cursor-pointer"
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12Z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                        </button>
                        {Number(item?.revenue_pending)>0 &&
                        <button
                          className={`bg-primary rounded-xl py-1 px-3 text-white ${userRole != UserRole.Admin ? "opacity-50 cursor-not-allowed": "cursor-pointer"}  hover:bg-primary/90 `} 
                          onClick={() => handlePayout(item)}
                          disabled = {userRole != UserRole.Admin}
                        >
                          Payout
                        </button>
                      }
                      </div>
                    </td>
                    
                  </tr>
                ))
              ) : (
                !loading && (
                  <tr>
                    <td
                      colSpan="6"
                      className="px-6 py-3 text-sm font-normal text-textcolor"
                    >
                      <div className="flex justify-center items-center mt-5">
                        <img
                          src={ImagePath?.NoDataFound}
                          alt="No Data Found"
                          style={{ width: 70, height: 70 }}
                        />
                      </div>
                      <p className="text-xl mt-2 text-center">No data found</p>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
      {openPayoutModal && (
        <AddPayoutModal
          onClose={() => setOpenPayoutModal(false)}
          clubDetail={clubDetail}
          fetchRevenueData={fetchRevenueData}

        />
      )}
      {openTransactionModal && 
      <PayoutTransactions
      onClose = {()=>setOpenTransactionModal(false)}
       clubDetail={clubDetail}
      />
      }
      <CommonPagination
        currentPage={currentPage}
        pageCount={totalCount}
        onPageChange={(e) => handlePageChange(e)}
      />
    </>
  );
};

export default RevenueManagement;
